import {changeEvent} from "../../../webpack/modules/events";
import {trackProductPageGa4Events, updateButtonsPrice} from "../../../webpack/modules-optimized/product";

changeEvent('input[name="complement"], input[name="cross-selling-product"]', true, function(element) {
    let container = element.closest('.product-scope') ? element.closest('.product-scope') : element.closest('.product-configuration');
    let analyticsAction = element.dataset.analyticsAction;
    let analyticsLabel = element.dataset.analyticsLabel;
    updateButtonsPrice(container);
    if (element.checked) trackProductPageGa4Events(analyticsAction, analyticsLabel);
});